import UICommunityNew from '@/scripts/legacy-ui-library/ui-community-new';

import _ from 'underscore';
import Ladda from 'ladda';
import UIHelper from '@/scripts/helpers/ui-helper';
import socialSharer from '@/scripts/libs/social-sharer';
import Toastr from 'toastr';

import webcall from '@/scripts/webcall';

let questionId = null;
let isInEditMode = false;

const _preInit = function _preInit() {
  return ($('#new-question').length !== 0);
};

const _bindUIActions = function _bindUIActions() {
  const $linkInput = $('.new-question__link__input input');
  $linkInput.bind('input propertychange', _onInputChangeWithDebounce);

  $('.new-question__topic-select').on('change', (e) => {
    const topic = $(e.currentTarget)
      .find('option:selected')
      .text()
    ;
    if (topic === 'Choose') {
      $('#new-question textarea.comment__new__title').attr('placeholder', 'Add a Title');
      const tplHelptextDefault = _.template($('.tpl-helptext-default').html());
      $('#new-question div.new-question__helptext').html(tplHelptextDefault());
      return;
    }

    webcall.community.getTopicInfo({
      topic,
    }, (res) => {
      if (res.community) {
        if (res.community.topic_placeholder) {
          $('#new-question textarea.comment__new__title').attr('placeholder', res.community.topic_placeholder);
        } else {
          $('#new-question textarea.comment__new__title').attr('placeholder', 'Add a Title');
        }
        if (res.community.topic_helptext) {
          $('#new-question div.new-question__helptext').html(res.community.topic_helptext);
        } else {
          const tplHelptextDefault = _.template($('.tpl-helptext-default').html());
          $('#new-question div.new-question__helptext').html(tplHelptextDefault());
        }
      } else {
        $('#new-question textarea.comment__new__title').attr('placeholder', 'Add a Title');
        const tplHelptextDefault = _.template($('.tpl-helptext-default').html());
        $('#new-question div.new-question__helptext').html(tplHelptextDefault());
      }
    });
  });

  $('.new-question')
    .parsley()
    .on('form:submit', () => {
      const l = Ladda.create(document.getElementById('new-question__publish'));
      l.start();
      _publishQuestion(l);
      return false;
    });

  $('.new-question-content').on('click', '.js-published-share', (e) => {
    const $el = $(e.currentTarget);
    const params = {
      url: $el.closest('.new-question-published__share').data('url') + '?utm_source=viddsee&utm_medium=community-new&utm_campaign=share',
    };
    switch ($el.data('type')) {
      case 'facebook':
        socialSharer.shareFB(e, params);
        break;
      case 'twitter':
        socialSharer.shareTW(e, params);
        break;
      case 'email':
        params.subject = 'Invite to my discussion on Viddsee';
        socialSharer.shareEmail(e, params);
        break;
      default: break;
    }
  });
};

const _onInputChangeWithDebounce = _.debounce((e) => {
  const $urlString = e.target.value;
  $('.new-question__link .embed-link').remove();
  if (_isURL($urlString)) {
    const options = { url: $urlString };

    webcall.getLinkPreview(options, (res) => {
      if (res !== 'error') {
        const tplEmbedLink = _.template($('.tpl-embed-link').html());
        $('.new-question__link').append(tplEmbedLink({
          description: res.description,
          title: res.title,
          image: res.image,
          domain: _getDomainFromString(typeof res.url === 'undefined' ? $urlString : res.url),
        }));
        e.target.value = typeof res.url === 'undefined' ? $urlString : res.url;
      }
    });
  }
}, 500);

const _isURL = function _isURL(str) {
  const pattern = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/ig;
  return pattern.test(str);
};

const _getDomainFromString = function _getDomainFromString(str) {
  const matches = str.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
  return matches && matches[1];
};

const _publishQuestion = function _publishQuestion(ladda) {
  const params = {};
  const newQuestionForm = document.getElementById('new-question');
  [...newQuestionForm.elements].filter((element) => !!(element.name))
    .forEach((element) => {
      params[element.name] = element.value;
    });

  // TODO: This is a crude Implementation of edit feature by hijacking the previous new post codes
  const webcallMethods = (isInEditMode)
    ? {
      main: webcall.community.updateQuestion,
      postMain() { window.location = `/community/question/${questionId}`; },
    } : {
      main: webcall.community.postNewQuestion,
      postMain(response) {
        const $question = response;
        $question.body = UIHelper.simpleFormat($question.body);

        const tplPublished = _.template($('.tpl-published').html());
        $('.new-question-content').html(tplPublished({
          response: $question,
        }));
        UIHelper.relativeTime();
      },
    };
  const options = {
    question_id: questionId,
    params,
  };

  Promise.resolve(params)
    .then(params => webcallMethods.main(options))
    .then(webcallMethods.postMain)
    .catch((error) => {
      Toastr.error(error, 'Error');
    })
    .then(() => { // Finally
      ladda.stop();
      window.scrollTo(0, 0);
    });
};

const VSCommunityQuestionNew = {
  init() {
    if (!_preInit()) return;

    // TODO: This is a crude Implementation of edit feature by hijacking the previous new post codes
    questionId = document.getElementById('new-question').dataset.questionId;
    isInEditMode = (questionId != null);

    UICommunityNew.registerEventBindings();
    _bindUIActions();
  },
};

export default VSCommunityQuestionNew;
